// errorElement for the authenticated app routes. Replaces React Router's raw
// dev error page with a calm screen. This side is baker-only, so the technical
// message is shown (muted) to help debugging, plus a reload.

import type { ReactElement } from "react";
import { isRouteErrorResponse, useRouteError } from "react-router-dom";
import { LocalRouteErrorScreen } from "./LocalRouteErrorScreen";

function errorMessage(error: unknown): string {
  if (error instanceof Error) return error.message;
  if (typeof error === "string") return error;
  if (error !== null && typeof error === "object" && "statusText" in error) {
    const statusText = error.statusText;
    if (typeof statusText === "string") return statusText;
  }
  return "Unknown error";
}

export function RouteErrorScreen(): ReactElement {
  const error = useRouteError();
  console.error("Route error", error);
  return (
    <LocalRouteErrorScreen
      missing={isRouteErrorResponse(error) && error.status === 404}
      message={errorMessage(error)}
    />
  );
}
